import React from 'react';
import { ReactComponent as ContactPhoneIcon } from 'Assets/svg/contact-phone.svg';
import { ReactComponent as CopyIcon } from 'Assets/svg/copy.svg';
import { ReactComponent as LockIcon } from 'Assets/svg/lock.svg';
import { toasterState } from 'Components/common/toaster';
import { advSearchState } from 'Stores/advSearch';
import userDetail from 'Stores/userDetail';
import * as CONSTANTS from 'Utils/constants';
import { Utils } from 'Utils/utils';
import Dropdown from '../../dropdown';
import './styles.scss';
import FeatureLockedTooltip from '../../FeatureLockedTooltip';

function copyContactInfo(number, pageName) {
  Utils.copyToClipBoard(number);
  if (pageName === 'advsearch')
    Utils.mixpanelTrack(CONSTANTS.MX_AS_EVENTS.AS_COPY_CLICKED, {
      type: 'phone',
    });
  else if (pageName === 'myleads')
    Utils.mixpanelTrack(CONSTANTS.MX_ML_EVENTS.ML_COPY_CLICKED, {
      type: 'phone',
    });
  toasterState.setToastMsg('Copied', 'success-new');
}

const PhoneItem = props => {
  const { phoneNumber, pageName, Icon = ContactPhoneIcon, tag = '' } = props;

  return (
    <div className="phone-wrapper owned">
      <div className="info-icon">
        <Icon />
      </div>
      <div className="info-detail show-elipsis">{phoneNumber}</div>
      {tag && <div className="tag">{tag}</div>}
      <CopyIcon
        className="copy-icon"
        onClick={e => {
          e.preventDefault();
          copyContactInfo(phoneNumber, pageName);
        }}
        data-value={phoneNumber}
      />
    </div>
  );
};

const ContactPhone = props => {
  const {
    phone = null,
    contactId,
    purchaseMobile = CONSTANTS.EMPTY_FUNCTION,
    pageName,
  } = props;

  return (
    <div className="contact-phone">
      {phone === null ? (
        Utils.isLBPaidSubscription() &&
        !userDetail.userInfo.phoneVendorPurchaseEnabled ? (
          <FeatureLockedTooltip
            callback={() => {
              Utils.mixpanelTrack(
                CONSTANTS.MOBILE_NUMBER_EVENTS
                  .MOBILE_NUMBER_UPGRADE_POPUP_SHOWN,
              );
            }}
            featureEnabled={userDetail.userInfo.phoneVendorPurchaseEnabled}
            className="mobile-number-locked"
            iconContent={
              <div className="phone-wrapper">
                <div className="info-icon">
                  <ContactPhoneIcon />
                </div>
                <div className="info-detail show-elipsis">+***-***-****</div>
                <div className="tag">Mobile</div>
                <div className="lock-wrapper">
                  <LockIcon />
                </div>
              </div>
            }
          >
            Mobile Numbers are not available in your current plan. Please
            upgrade your plan to get access.
            <button
              type="button"
              onClick={() => {
                advSearchState.notifyMobileNumberInterest();
                window.open(CONSTANTS.PAGE_PATH_MAP.PRICING, '_blank');
              }}
            >
              Upgrade Now
            </button>
          </FeatureLockedTooltip>
        ) : (
          <div className="phone-wrapper">
            <div className="info-icon">
              <ContactPhoneIcon />
            </div>
            <div
              className="info-detail show-elipsis"
              onClick={e => {
                if (userDetail.userInfo.phoneVendorPurchaseEnabled)
                  purchaseMobile(contactId);
              }}
            >
              +***-***-****
            </div>
            <div className="tag">Mobile</div>
          </div>
        )
      ) : (
        phone.length > 0 && (
          <div className="number-with-more-text">
            <PhoneItem
              phoneNumber={phone[0]}
              pageName={pageName}
              tag="Mobile"
            />
            {phone.length > 1 && (
              <Dropdown
                toggleElement={
                  <span className="more-phone">{`+${phone.length -
                    1} More`}</span>
                }
                offsetValues={{ top: 60 }}
              >
                {phone.slice(1).map(phoneNumber => {
                  return (
                    <PhoneItem
                      key={phone}
                      phoneNumber={phoneNumber}
                      pageName={pageName}
                    />
                  );
                })}
              </Dropdown>
            )}
          </div>
        )
      )}
    </div>
  );
};

export { PhoneItem };
export default ContactPhone;
